var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoPump(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 18,
    viewBox: "0 0 31 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0.500192L23.7812 4.77519L31 9.50019H17V0.500192Z",
    fill: "#012946"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 0.807879L23.6696 4.7477L30.4616 9.15403H17.5001V0.807879Z",
    fill: "#002D62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 9.00018L24.2188 4.72518L17 0.000181198H31V9.00018Z",
    fill: "#0679CC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.26892 16.4239L7.84588 11.847L12.4228 16.4239H3.26892Z",
    fill: "#002D62"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84644 4.00019H15.0388V5.96174H7.84644V4.00019Z",
    fill: "#0679CC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0385 4.32743H17V5.63513H15.0385V4.32743Z",
    fill: "#002D62"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.65588 8.57715C2.62916 8.79134 2.61541 9.00956 2.61541 9.231C2.61541 9.45243 2.62916 9.67065 2.65588 9.88485H0V8.57715H2.65588ZM2.65588 8.57715C2.97763 5.99684 5.17875 4.00019 7.84622 4.00019C10.7351 4.00019 13.077 6.3421 13.077 9.231C13.077 12.1199 10.7351 14.4618 7.84622 14.4618C5.17875 14.4618 2.97763 12.4651 2.65588 9.88485H6.71346C6.93957 10.2757 7.36218 10.5387 7.84622 10.5387C8.56844 10.5387 9.15392 9.95322 9.15392 9.231C9.15392 8.50877 8.56844 7.92329 7.84622 7.92329C7.36218 7.92329 6.93957 8.18627 6.71346 8.57715H2.65588Z",
    fill: "#0679CC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.26892 16.4236H12.4228V17.0774H3.26892V16.4236Z",
    fill: "#012946"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.57742H2.61541V9.88513H0V8.57742Z",
    fill: "#002D62"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.57742H2.61541V9.88513H0V8.57742Z",
    fill: "#002D62"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84612 10.539C8.56834 10.539 9.15381 9.95349 9.15381 9.23127C9.15381 8.50905 8.56834 7.92358 7.84612 7.92358C7.36209 7.92358 6.93948 8.18655 6.71338 8.57742H2.61536V9.88512H6.71338C6.93948 10.276 7.36209 10.539 7.84612 10.539Z",
    fill: "#002D62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoPump);
export default __webpack_public_path__ + "static/media/RO_Pump.733771efce87a23ae4b5a064fb5d1786.svg";
export { ForwardRef as ReactComponent };